<template>
    <div class="contact">
        <b-container fluid>
            <b-modal id="modal-center" centered hide-footer hide-header>
                <div class="text-center modal-wrapper">
                    <img class="img-modal" src="../assets/img/icn_confirmation.svg" alt="">
                    <p class="title-modal">Your email has been sent</p>
                    <p class="text-modal">We will get back to you as soon as possible.</p>
                </div>
            </b-modal>
            <b-row>
                <b-col md="12">
                    <p>Contact Us</p>
                </b-col>
                <b-col md="7">
                    <h1>It is our pleasure to be part of the achievement of your projects</h1>
                    <b-row class="form-wrapper"> 
                        <b-col md="6" class="mb-3 form-floating">
                            <b-form-input id="input-1" v-model="name" placeholder="Name*" type="text"></b-form-input>
                            <label for="input-1">Name*</label>
                        </b-col>
                        <b-col md="6" class="mb-3 form-floating">
                            <b-form-input id="input-2" v-model="email" placeholder="Email*" type="text"></b-form-input>
                            <label for="input-2">Email*</label>
                        </b-col>
                        <b-col md="6" class="mb-3 form-floating">
                            <b-form-input id="input-3" v-model="country" placeholder="Country*" type="text"></b-form-input>
                            <label for="input-3">Country*</label>
                        </b-col>
                        <b-col md="6" class="mb-3 form-floating">
                            <b-form-input id="input-4" v-model="subject" placeholder="Subject*" type="text"></b-form-input>
                            <label for="input-4">Subject*</label>
                        </b-col>
                        <b-col md="12" class="mb-5 form-floating">
                            <b-form-input id="input-5" v-model="message" placeholder="Tell us about your project" type="text"></b-form-input>
                            <label for="input-5">Tell us about your project</label>
                        </b-col>
                        <b-col md="12" class="mb-3 form-floating">
                            <b-button class="mb-5" v-on:click="sendMessage">Send email</b-button>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col class="5">
                    <p class="address"><img class="icon" src="../assets/img/icn_phone.svg" alt=""> +52 (686) 546 6856</p> 
                    <p class="address"><img class="icon" src="../assets/img/icn_location.svg" alt=""> Av. Republica de Brasil #259 Col. Cuauhtémoc Norte, Mexicali, B.C., C.P. 21220</p> 
                    <p class="address"><img class="icon" src="../assets/img/icn_location.svg" alt=""> 280 Avenida Campillo, Suite I, Calexico, CA 92231</p> 
                    <img src="../assets/img/img_contact.jpg" class="img-fluid mt-4" alt="">
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                name: '',
                email: '',
                country: '',
                subject: '',
                message: '',
                responseData: ''
            }
        },
        methods: {
            async sendMessage(){
                if(this.name != '' && this.email != '' && this.country != '' && this.subject != ''){
                    await axios.post('/vendor/send-mail.php', {
                        name: this.name,
                        email: this.email,
                        country: this.country,
                        subject:  this.subject,
                        message: this.message
                    })
                    .then((response) => {
                        this.responseData = response.data
                    })
                    .catch((error) => {
                        /* eslint-disable no-console */
                        console.log(error);
                        /* eslint-enable no-console */
                    });
                    
                    if(this.responseData==200 || this.responseData=='200') {
                        this.name = '',
                        this.email = '',
                        this.country = '',
                        this.subject = '',
                        this.message = ''
                        this.$bvModal.show('modal-center')
                    }
                }
            }
        }
    }
</script>

<style scoped>
.contact{
    background: #C80B4B;
    color: #fff;
    padding: 8% 5%;
}
h1{
    margin-bottom: 80px;
}
.btn{
    text-align: center;
    background: #fff;
    color: #C80B4B;
    border-color: #fff;
    font-size: 30px;
    width: 80%;
    outline: none !important;
}
.address{
    padding-left: 40px;
    font-size: 25px;
    position: relative;
    margin-bottom: 5px;
}
.btn:focus,
.btn:hover,
.btn:active{
    background: #fff !important;
    color: #C80B4B !important;
    outline: none;
    border-color: #fff !important;
}
.icon{
    position: absolute;
    margin-left: -40px;
    top: 8px;
}

/* FORM */
.form-wrapper{
    width: 87%;
}
.form-floating > .form-control{
    background: transparent;
    border: none;
    border-bottom: #fff solid 1px;
    border-radius: 0;
    color: #fff;
    font-size: 25px;
    padding-left: 0;
    outline: none !important;
}
.form-floating > .form-control, .form-floating > .form-control-plaintext, .form-floating > .form-select {
    height: calc(4rem + 2px);
}
input:focus,
input:active{
    outline: none !important;
    box-shadow: none !important;
}
.form-floating label{
    font-size: 25px;
}

/* MODAL */
.modal-wrapper{
    padding: 100px 10px;
}
.img-modal{
    margin-bottom: 28px;
}
.title-modal{
    margin-bottom: 0;
    font-family: "effra", sans-serif;
    font-weight: 400;
    font-size: 40px;
}
.text-modal{
    margin-bottom: 0;
    font-family: "effra", sans-serif;
    font-weight: 400;
    font-size: 30px;
    margin: auto;
    width: 70%;
}

@media (max-width: 1600px){
    h1{
        font-size: 45px;
    }
    .btn{
        font-size: 23px;
    }
    .address{
        font-size: 20px;
    }
    .form-floating > .form-control,
    .form-floating label{
        font-size: 20px;
    }
    .icon{
        height: 20px;
        top: 5px;
    }

    .modal-wrapper{
        padding: 60px 10px;
    }
    .img-modal{
        margin-bottom: 20px;
    }
    .title-modal{
        font-size: 30px;
    }
    .text-modal{
        font-size: 25px;
    }
}

@media (max-width: 768px){
    h1{
        font-size: 35px;
    }
    .btn{
        width: 100%;
    }
    .form-wrapper{
        width: 100%;
    }
    .contact{
        padding: 15% 5%;
    }

    .modal-wrapper{
        padding: 40px 10px;
    }
    .img-modal{
        width: 55px;
    }
    .title-modal{
        font-size: 25px;
    }
    .text-modal{
        font-size: 20px;
    }
}
</style>